import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // Extrae el `pathname` del objeto de ubicación actual.
  const { pathname } = useLocation();

  // Este efecto se ejecutará cada vez que el `pathname` cambie.
  useEffect(() => {
    // Hace scroll de la ventana a la posición (0, 0) - la esquina superior izquierda.
    window.scrollTo(0, 0);
  }, [pathname]); // El array de dependencias asegura que el efecto solo se ejecute al cambiar de ruta.

  // Este componente no necesita renderizar nada en la UI.
  return null;
};

export default ScrollToTop;